import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ModalComp } from "../ModalComp";
import { AutomationWidgets } from "./AutomationWidgets";
const AutomationZones = (props) => {
  const { title, icon, setAutomationCommand, automationId } = props;
  const [zoneCaption, setZoneCaption] = useState("");
  const [zoneIndex, setZoneIndex] = useState();
  const [zoneId, setZoneId] = useState();
  const { t } = useTranslation();
  const [openAutomationWidgets, setOpenAutomationWidgets] = useState(false);
  //   const [automationId,setAutomationId]=useState("")

  const toggleAutomationsWidgets = () => {
    setOpenAutomationWidgets(!openAutomationWidgets);
  };
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );

  const zoneClicked = (value, index) => {
    setZoneCaption(value.zone_caption);
    setZoneIndex(index);
    setZoneId(value.id);
    setOpenAutomationWidgets(true);
  };
  return (
    <>
      <ModalComp
        modal={openAutomationWidgets}
        toggle={toggleAutomationsWidgets}
        component={
          <AutomationWidgets
            id={zoneId}
            setAutomationCommand={setAutomationCommand}
            automationId={automationId}
            zoneCaption={zoneCaption}
          />
        }
      />
      <div className="text-right">
        <div className="d-flex justify-content-center my-3  ">
          <div className="d-flex flex-column align-items-center gap-3  ">
            <small>
              {t("ناحیه ای که دستگاه شما در آن قرار دارد را انتخاب نمایید.")}
            </small>
            <small
              className="addScenarioIcon rounded-circle d-block py-1
               text-center  border-0 "
            >
              <i className={`${icon}  text-white  `}></i>
            </small>

            <div className="text-center mt-2">
              <p className="m-0"> {title}</p>
            </div>
          </div>
        </div>
        <div className="my-4" style={{ minHeight: "80vh" }}>
          {dashboardZones?.map((zone, index) => {
            let active = zoneIndex === index ? "selectZonesActive" : "";
            return (
              <div
                className={`selectZones text-center py-3 my-2 cursor ${active}`}
                key={index}
                onClick={() => zoneClicked(zone, index)}
              >
                <p className="m-0 fn">{zone.zone_caption}</p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
export { AutomationZones };
